
export const CookiePolicyData = (url: any) => {
    if(url!="/privacy-policy/"){
    return(
        `<p>Adecco Group India, 13th Floor, Summit B, Brigade Metropolis, Garudachar Palya, Mahadevapura Post, Bengaluru is committed to providing you with the best online experience while visiting the adecco.co.in website (the “Website”) and committed to protecting and respecting your privacy. To achieve this, we utilize our own and standard third-party cookies to obtain data about your online behavior while you are on the website, and we also track how often you visit the website. The information we collect is anonymous and does not identify you as an individual unless you provide us with your information by completing in a form, or through another feature offered on the website. Where personal information is collected by Adecco, such collection is covered by our Privacy Policy, available <a href='/privacy-policy'>here</a>.</p><p><b>What are we keeping</b></p><p>We do not use cookies that are intrusive on the Websites to collect your personal data. We use standard third-party cookies such as Google Analytics to track your surfing behavior and to collect aggregate statistical data in the following ways. We do this in the following ways:</p><ul><li> We record the number of visits to the website where every visitor comes from (ie. the website you visited before you surfed to the website) and where every visitor goes from the website (ie. the website that you visit after you leave our website).</li><li> A cookie is stored on your device for no longer than 2 years. This is linked to your IP address. Cookies are small text files that your web browser stores on your device. Then we can keep track of when you return to the website.</li></ul><p><b>How can you manage cookies yourself?</b></p><p>Unless you have specified in your browser settings that cookies should be refused, our systems will issue cookies every time you visit the website.</p><p>You can refuse cookies by setting this in the browser that does not permit you to store cookies. This clears all cookie data. However, if you choose this setting, you may no longer have access to certain parts of the website, or you may no longer be able to use certain functionalities.</p><p><b>Third party cookies</b></p>During your visit to the website you can also find content from third parties. We can also offer you the opportunity to contact us and exchange information with others via social networks such as Facebook, LinkedIn, and Twitter. This content is added so that we can offer you carefully selected information that you may find relevant or interesting. This means that third-party providers can store additional cookies on your device over which we have no control. Consequently, we recommend that you check the websites of such third parties and read their privacy policies for more information about their cookies and how you can manage them.</p><p><b>Cookies on adecco.co.in</b></p><p>The website may contain links to third-party websites. If you follow a link to a third-party website, please note that such websites have their own privacy and cookie policies and that we accept no responsibility or liability for that policy. Please read this policy before providing personal information to such third-party websites.</p><p><b>Changes to this Cookie Policy</b></p><p>The terms of this policy may change from time to time. We will publish any changes that we will make to this Cookie Policy by making appropriate notifications on this website or by contacting you through other communication channels.</p><p><b>Contact</b></p>Do not hesitate to send any questions, comments, and requests regarding this Cookie Policy to <a href='mailto:wecare@adecco.co.in' style='color:blue'>wecare@adecco.co.in</a> .</p>`
    )
    }
    else{
        return(
                `<p>Adecco Group India, 13th Floor, Summit B, Brigade Metropolis, Garudachar Palya, Mahadevapura Post, Bengaluru is committed to providing you with the best online experience while visiting the adecco.co.in website (the “Website”) and committed to protecting and respecting your privacy. To achieve this, we utilize our own and standard third-party cookies to obtain data about your online behavior while you are on the website, and we also track how often you visit the website. The information we collect is anonymous and does not identify you as an individual unless you provide us with your information by completing in a form, or through another feature offered on the website. Where personal information is collected by Adecco, such collection is covered by our Privacy Policy, available <a href=''>here</a>.</p><p><b>What are we keeping</b></p><p>We do not use cookies that are intrusive on the Websites to collect your personal data. We use standard third-party cookies such as Google Analytics to track your surfing behavior and to collect aggregate statistical data in the following ways. We do this in the following ways:</p><ul><li> We record the number of visits to the website where every visitor comes from (ie. the website you visited before you surfed to the website) and where every visitor goes from the website (ie. the website that you visit after you leave our website).</li><li> A cookie is stored on your device for no longer than 2 years. This is linked to your IP address. Cookies are small text files that your web browser stores on your device. Then we can keep track of when you return to the website.</li></ul><p><b>How can you manage cookies yourself?</b></p><p>Unless you have specified in your browser settings that cookies should be refused, our systems will issue cookies every time you visit the website.</p><p>You can refuse cookies by setting this in the browser that does not permit you to store cookies. This clears all cookie data. However, if you choose this setting, you may no longer have access to certain parts of the website, or you may no longer be able to use certain functionalities.</p><p><b>Third party cookies</b></p>During your visit to the website you can also find content from third parties. We can also offer you the opportunity to contact us and exchange information with others via social networks such as Facebook, LinkedIn, and Twitter. This content is added so that we can offer you carefully selected information that you may find relevant or interesting. This means that third-party providers can store additional cookies on your device over which we have no control. Consequently, we recommend that you check the websites of such third parties and read their privacy policies for more information about their cookies and how you can manage them.</p><p><b>Cookies on adecco.co.in</b></p><p>The website may contain links to third-party websites. If you follow a link to a third-party website, please note that such websites have their own privacy and cookie policies and that we accept no responsibility or liability for that policy. Please read this policy before providing personal information to such third-party websites.</p><p><b>Changes to this Cookie Policy</b></p><p>The terms of this policy may change from time to time. We will publish any changes that we will make to this Cookie Policy by making appropriate notifications on this website or by contacting you through other communication channels.</p><p><b>Contact</b></p>Do not hesitate to send any questions, comments, and requests regarding this Cookie Policy to <a href='mailto:wecare@adecco.co.in' style='color:blue'>wecare@adecco.co.in</a> .</p>`
        )
    }

}

export const cookiesPolicyPageData = {
    heading: "Cookie policy",
    cookieDetails1: '<h3 class="fw-600">Cookie policy</h3><p>Adecco Group India, 13th Floor, Summit B, Brigade Metropolis, Garudachar Palya, Mahadevapura Post, Bengaluru  (“Adecco”, “we” or “us”) is committed to providing you with the best online experience while visiting the adecco.co.in website (the “Website”) and committed to protecting and respecting your privacy. To achieve this, we utilize our own and standard third-party cookies to obtain data about your online behavior while you are on the website, and we also track how often you visit the website. The information we collect is anonymous and does not identify you as an individual unless you provide us with your information by completing in a form, or through another feature offered on the website. Where personal information is collected by Adecco, such collection is covered by our Privacy Policy, available here. <a href="/privacy-policy">Privacy policy</a></p><h3 class="fw-600">What are we keeping</h3><p>We do not use cookies that are intrusive on the Websites to collect your personal data. We use standard third-party cookies such as Google Analytics to track your surfing behavior and to collect aggregate statistical data in the following ways. We do this in the following ways:<ul><li>We record the number of visits to the website where every visitor comes from (ie. the website you visited before you surfed to the website) and where every visitor goes from the website (ie. the website that you visit after you leave our website).</li><li>A cookie is stored on your device for no longer than 2 years. This is linked to your IP address. Cookies are small text files that your web browser stores on your device. Then we can keep track of when you return to the website.</li></ul></p><h3 class="fw-600">How can you manage cookies yourself?</h3><p>Unless you have specified in your browser settings that cookies should be refused, our systems will issue cookies every time you visit the website.<br/>You can refuse cookies by setting this in the browser that does not give you permission to store cookies. This clears all cookie data. However, if you choose this setting, you may no longer have access to certain parts of the website, or you may no longer be able to use certain functionalities.</p><h3 class="fw-600">Third party cookies</h3><p>During your visit to the website you can also find content from third parties. We can also offer you the opportunity to contact us and exchange information with others via social networks such as Facebook, LinkedIn, and Twitter. This content is added so that we can offer you carefully selected information that you may find relevant or interesting. This means that third-party providers can store additional cookies on your device over which we have no control. Consequently, we recommend that you check the websites of such third parties and read their privacy policies for more information about their cookies and how you can manage them.</p><h3 class="fw-600">Cookies on adecco.co.in</h3><p>The website may contain links to third-party websites. If you follow a link to a third-party website, please note that such websites have their own privacy and cookie policies and that we accept no responsibility or liability for that policy. Please read this policy before providing personal information to such third-party websites.</p><p>Below are examples of cookies used on adecco.co.in, including details about their purpose and other information that may be useful to you. If you wish to log in to third-party websites via adecco.co.in., note that the list of cookies below may not be comprehensive.</p>',
    cookieDetails2: '<h3 class="fw-600">Changes to this Cookie Policy</h3><p>The terms of this policy may change from time to time. We will publish any changes that we will make to this Cookie Policy by making appropriate notifications on this website or by contacting you through other communication channels.</p><h3 class="fw-600">Contact</h3><p>Do not hesitate to send any questions, comments, and requests regarding this Cookie Policy to wecare@adecco.co.in .</p>',
    columns: [
      {
        title: 'Cookie Name',
        dataIndex: 'cookieName',
        key: 'cookieName',
      },
      {
        title: 'Purpose',
        dataIndex: 'purpose',
        key: 'purpose',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
      },
      {
        title: 'Lifespan',
        dataIndex: 'lifespan',
        key: 'lifespan',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      }
    ],
    dataSource: [
      {
        cookieName: "_ga",
        purpose: "Performance",
        type: "APISID",
        lifespan: "persistant/2 years",
        description: "This cookie is used to distinguishes unique users by assigning a randomly generated number as a client identifier."
      },
      {
        cookieName: "_gat",
        purpose: "APISID",
        type: "Third party",
        lifespan: "persistant/10 minutes",
        description: "This cookie name is associated with Google Universal Analytics, according to documentation it is used to throttle the request rate - limiting the collection of data on high traffic sites. It expires after 10 minutes."
      },
      {
        cookieName: "_timerCookie",
        purpose: "Login_Info",
        type: "First party",
        lifespan: "session",
        description: "It is used for ssp session login duration"
      },
      {
        cookieName: "adeccouniqueid",
        purpose: "Login_Info",
        type: "First party",
        lifespan: "session",
        description: "Addeco specified unique id for ssp login"
      },
      {
        cookieName: "ai_session, ai_user, ai_authUser",
        purpose: "Login_Info",
        type: "First party",
        lifespan: "sessiona",
        description: "Apllication insight for data analytics."
      },
      {
        cookieName: "ASP.NET_SessionId",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "creates a new client request to post the downloaded document to the proxy. "
      },
      {
        cookieName: "authId",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "Authentication id for set user session"
      },
      {
        cookieName: "browserIncompatibleWarning",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "If the cookie does not exist in the browser then this warning is shown using this cookie"
      },
      {
        cookieName: "CandidateCookieValue",
        purpose: "ai_session",
        type: "First party",
        lifespan: "7 days",
        description: "It is for candiadate page value in the browser"
      },
      {
        cookieName: "Cookie-BranchLocatorRootItem",
        purpose: "ASP.NET_SessionId",
        type: "First party",
        lifespan: "session",
        description: "It stores the root item of branch locator in sitecore."
      },
      {
        cookieName: "CurrentControl",
        purpose: "_ASP.NET",
        type: "First party",
        lifespan: "session",
        description: "Distinguish different controls (savedjobs/matchedjobs/findjobs/jobresults) using CurrentControl cookie value"
      },
      {
        cookieName: "CurentPage",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It will store the numeric value of curent page i.e 1,2"
      },
      {
        cookieName: "currLang",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It will get the cookie value of current language"
      },
      {
        cookieName: "ieRedirect",
        purpose: "ai_session",
        type: "First party",
        lifespan: "",
        description: "If SSP redirect did not occur (as in IE10), set new cookie to redirect server side)"
      },
      {
        cookieName: "IsJobPage",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "to note down whether the user came from job page, expiredpage, thankyou page"
      },
      {
        cookieName: "IsNewlyLoggedIn",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "Set 'Newly Logged In' cookie to false to prevent redirect when navigating back to homepage"
      },
      {
        cookieName: "IsNewProfile",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "If this is a new profile (but existing Candidate account), redirect to SSP Import Profile page"
      },
      {
        cookieName: "JobsBrowsebyCategoryURL",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "This cookie contains Job search url of pagination item (URL in browser will not effect by click on Next/Previous pagination)"
      },
      {
        cookieName: "kAutoSelected",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It stores the value of keyword auto selected from suggestion"
      },
      {
        cookieName: "Locale",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It keeps track of the language by means of a cookie, so the language is preserved no matter of the user is logged in or not. It also works for recurring users."
      },
      {
        cookieName: "lAutoSelected",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It stores the value of location auto selected from suggestion"
      },
      {
        cookieName: "lUserTyped",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It stores the value of location typed by the user"
      },
      {
        cookieName: "JobsProviderName",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It stores the Job provider name like 'google'"
      },
      {
        cookieName: "modis.us#lang",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It is used for country and language"
      },
      {
        cookieName: "PageList",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It is used for listing of pages if current page is 1 then page list is 0"
      },
      {
        cookieName: "PortalCookieStorage",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "Setting configuration from sitecore , Provides a class that stores portlets in a browser cookie "
      },
      {
        cookieName: "PremiumPages, OneTimePremium, premiumContentCookies, premiumCookies",
        purpose: "ai_session",
        type: "First party",
        lifespan: "persistant/ 1 Day",
        description: "Used for premiuim pages"
      },
      {
        cookieName: "rsCookie",
        purpose: "_mkto_trk",
        type: "First party",
        lifespan: "1 year",
        description: "Recent search cookie  "
      },
      {
        cookieName: "SavedNotification",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It is used for saving the notification"
      },
      {
        cookieName: "SearchPage, SearchResultPage",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It shows the result page of searched job+ url+path  "
      },
      {
        cookieName: "selectedSiteForBranchSync",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It handles the selected site for branch sync module  "
      },
      {
        cookieName: "selectedLanguageForBranchSync",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It handles the selected language for branch sync module  "
      },
      {
        cookieName: "ShortListedJobs",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "For shortlisting of jobs"
      },
      {
        cookieName: "ShowSavedJobNotification",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It will show the saved job notification in ssp  "
      },
      {
        cookieName: "siteNameForRegister",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It is used for identify site name.  "
      },
      {
        cookieName: "slCookie",
        purpose: "ai_session",
        type: "First party",
        lifespan: "1 year",
        description: "Shortlisted cookie  "
      },
      {
        cookieName: "SortOrder",
        purpose: "ai_session",
        type: "First party",
        lifespan: "session",
        description: "It is used for sorting the order of page starting with 0  "
      },
      {
        cookieName: "userstatus",
        purpose: "ai_session",
        type: "First party",
        lifespan: "7 days",
        description: "It is used identify the status of user eg. Employer or Candidate.  "
      },
      {
        cookieName: "VisitorPreferenceKeyword + Site Name",
        purpose: "ai_session",
        type: "First party",
        lifespan: "7 days",
        description: "It stores the value of the Keyword searched by the User  "
      },
      {
        cookieName: "VisitorPreferencelocation + Site Name",
        purpose: "ai_session",
        type: "First party",
        lifespan: "7 days",
        description: "It stores the value of the Location searched by the User  "
      },
      {
        cookieName: "VisitorPreferencexy + Site Name",
        purpose: "ai_session",
        type: "First party",
        lifespan: "7 days",
        description: "It stores the value of the co-ordinates searched by the User  "
      } 
    ]
  }